const normalizeUrl = (value, variableName) => {
  const normalizedValue = value?.trim().replace(/\/+$/, "");

  if (!normalizedValue) {
    throw new Error(`Missing required environment variable: ${variableName}`);
  }

  try {
    new URL(normalizedValue);
  } catch (error) {
    throw new Error(`Invalid URL configured in environment variable: ${variableName}`);
  }

  return normalizedValue;
};

export const APP_URL = normalizeUrl(
  process.env.REACT_APP_APP_URL,
  "REACT_APP_APP_URL"
);

export const WEBSITE_URL = normalizeUrl(
  process.env.REACT_APP_WEBSITE_URL,
  "REACT_APP_WEBSITE_URL"
);

export const HOME_CONTACT_FORM_URL = normalizeUrl(
  process.env.REACT_APP_HOME_CONTACT_FORM_URL,
  "REACT_APP_HOME_CONTACT_FORM_URL"
);

export const CONTACT_US_URL = normalizeUrl(
  process.env.REACT_APP_CONTACT_US_URL,
  "REACT_APP_CONTACT_US_URL"
);

export const PAYMENT_UPDATE_FORM_URL = normalizeUrl(
  process.env.REACT_APP_PAYMENT_UPDATE_FORM_URL,
  "REACT_APP_PAYMENT_UPDATE_FORM_URL"
);

export const CREDIT_REVIEW_URL = normalizeUrl(
  process.env.REACT_APP_CREDIT_REVIEW_URL,
  "REACT_APP_CREDIT_REVIEW_URL"
);

export const CLIENT_PORTAL_URL = normalizeUrl(
  process.env.REACT_APP_CLIENT_PORTAL_URL,
  "REACT_APP_CLIENT_PORTAL_URL"
);

export const CREDIT_REBUILDER_ENROLL_URL = normalizeUrl(
  process.env.REACT_APP_CREDIT_REBUILDER_ENROLL_URL,
  "REACT_APP_CREDIT_REBUILDER_ENROLL_URL"
);

export const COURSE_VIDEO_URL = normalizeUrl(
  process.env.REACT_APP_COURSE_VIDEO_URL,
  "REACT_APP_COURSE_VIDEO_URL"
);

export const FACEBOOK_URL = normalizeUrl(
  process.env.REACT_APP_FACEBOOK_URL,
  "REACT_APP_FACEBOOK_URL"
);

export const TWITTER_URL = normalizeUrl(
  process.env.REACT_APP_TWITTER_URL,
  "REACT_APP_TWITTER_URL"
);

const joinUrl = (baseUrl, path = "") =>
  `${baseUrl}/${path.replace(/^\/+/, "")}`;

export const buildAppUrl = (path = "") => joinUrl(APP_URL, path);
export const buildWebsiteUrl = (path = "") => joinUrl(WEBSITE_URL, path);

export const CREDIT_REBUILDER_ENROLL_SOURCE_URL =
  `${CREDIT_REBUILDER_ENROLL_URL}?typeform-source=${new URL(WEBSITE_URL).hostname}`;
